import React from "react";

const TransactionTabNavigation = ({ mode, activeTab, setActiveTab, editableStatus, visibilityAccess }) => {
  // MODIFIED: Define all potential tabs
  const allTabs = [
    {
      key: "assignment-details",
      label: "Assignment Details",
      editable: editableStatus.assignment,
      isVisible: visibilityAccess.isAssignmentDetailsTabVisible
    },
    {
      key: "employee-info",
      label: "Employee Info",
      editable: editableStatus.assignment,
      isVisible: visibilityAccess.isAssignmentDetailsTabVisible
    },
    {
      key: "compensation",
      label: "Compensation",
      editable: editableStatus.compensation,
      isVisible: visibilityAccess.isCompensationTabVisible
    },
    {
      key: "schedule",
      label: "Schedule",
      editable: editableStatus.schedule,
      isVisible: visibilityAccess.isScheduleTabVisible
    },
    {
      key: "other-info",
      label: "Other Info",
      isVisible: true,
      editable: true
    },
  ];

  // MODIFIED: Filter out 'other-info' if mode is 'add'
  const visibleTabs = allTabs.filter(tab => {
    if (!tab.isVisible) {
      return false;
    };

    if (mode === "add" && tab.key === "other-info") return false;
    return true;
  });

  return (
    <div className="border-b border-gray-200 bg-white pt-3">
      <div className="flex space-x-1 px-6">
        {visibleTabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-3 text-sm font-medium rounded-t-lg transition-colors border-b-2 flex items-center gap-2 border-none cursor-pointer 
                ${activeTab === tab.key
                ? "border-blue-500 text-blue-600 bg-blue-50"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TransactionTabNavigation;